import { createContext, useContext } from 'react';

import { DialogType, WithOptionalProps } from './types';

type DialogContextType = {
  openDialog: <T extends DialogType>(
    dialog: T,
    props?: WithOptionalProps<T>,
  ) => void;
  closeDialog: (dialog: DialogType) => void;
  closeAllDialogs: () => void;
};

const emptyFunc = (): void => {
  // empty
};

export const DialogContext = createContext<DialogContextType>({
  openDialog: emptyFunc,
  closeDialog: emptyFunc,
  closeAllDialogs: emptyFunc,
});

export const useDialog = (): DialogContextType => useContext(DialogContext);
